export default "__VITE_ASSET__Bnev95U___"